import privateConfig from "@/config/private.config";
import Stripe from "stripe";

let stripeClient: Stripe | null = null;

/**
 * Returns a Stripe client for server-side use (admin pricing CRUD, checkout).
 * Only available when STRIPE_SECRET_KEY is set.
 */
export function getStripeClient(): Stripe | null {
  if (!privateConfig.stripeSecretKey) {
    return null;
  }
  if (!stripeClient) {
    stripeClient = new Stripe(privateConfig.stripeSecretKey, {
      typescript: true,
    });
  }
  return stripeClient;
}

/**
 * Throws if Stripe is not configured (e.g. in server actions that require Stripe).
 */
export function requireStripeClient(): Stripe {
  const client = getStripeClient();
  if (!client) {
    throw new Error(
      "STRIPE_SECRET_KEY is not configured.",
    );
  }
  return client;
}
